<div class="flex flex-col" fxFlexFill>
  <h1 mat-dialog-title>Select A Scanner</h1>
  <div mat-dialog-content>
    <div *ngIf="!vinScan && !licenseScan" class="flex flex-row place-content-center place-items-center p-2">
      <div class="flex flex-col place-content-center place-items-center" fxFlex="25">
        <!-- <div>
          <h3>VIN</h3>
        </div>
        <button mat-icon-button style="width:150px; height:150px;" (click)="startVinScanner()">
          <mat-icon class="icon-display" svgIcon="barcode"></mat-icon>
        </button> -->
        <button mat-raised-button>
          <mat-icon svgIcon="barcode"></mat-icon> <span class="ml-2">VIN</span>
        </button>
      </div>
      <div class="flex flex-col place-content-center place-items-center" fxFlex="25">
        <!-- <div>
          <h3>License Plate</h3>
        </div>
        <button mat-icon-button style="width:150px; height:150px;" (click)="licenseScan = true">
          <mat-icon class="icon-display" svgIcon="barcode"></mat-icon>
        </button> -->
        <button mat-raised-button (click)="startLicensePlateScanner()">
          <mat-icon svgIcon="barcode"></mat-icon><span class="ml-2">Plate</span>
        </button>
      </div>


    </div>

    <div *ngIf="vinScan">
      <svc-app-barcode></svc-app-barcode>
    </div>
    <div *ngIf="licenseScan">
      <p>License Scan picked</p>
      <main id="camera">
        <!-- <video width="400px" height="400px" style="width:400px;height:400px" id="cameraSource" autoplay
          playsinline></video>
        <button mat-raised-button (click)="captureImage()"> capture</button>
        <canvas id="snapshot"></canvas> -->

        <!-- Camera sensor -->
        <canvas id="camera--sensor"></canvas>
        <!-- Camera view -->
        <video id="camera--view" autoplay playsinline #videoPlayer></video>
        <!-- Camera output -->
        <img src="//:0" alt="" id="camera--output">
        <!-- Camera trigger -->
        <button id="camera--trigger">Take a picture</button>
      </main>
      <!-- <input type="file" accept="image/*" capture="environment" (change)="changeFiles($event)"> -->

    </div>
  </div>
  <div mat-dialog-actions class="flex flex-row place-content-end place-items-center">
    <button mat-button [mat-dialog-close]="">Cancel</button>
  </div>
</div>